var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("h2", { staticClass: "panel-title mt-6" }, [_vm._v("Ayuda")]),
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("h2", { staticClass: "panel-title mt-6" }, [_vm._v("Ajuda")]),
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c(
          "div",
          [
            _c("h2", { staticClass: "panel-title mt-6" }, [
              _vm._v("Centro de Ayuda"),
            ]),
            _c("div", { staticClass: "card-item", attrs: { id: "support" } }, [
              _vm.user.rol === "CLIENT"
                ? _c("h3", [_vm._v("Gestiona tus consultas")])
                : _vm._e(),
              _vm.user.rol === "CLIENT"
                ? _c(
                    "div",
                    {
                      staticClass: "card-item shadowless",
                      attrs: { id: "new-ticket" },
                    },
                    [
                      _c("h4", [
                        _vm._v(" Nueva consulta "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-button-secondary is-pulled-right is-rounded",
                            on: { click: _vm.hideNewTicketForm },
                          },
                          [
                            _c("i", {
                              staticClass: "fas",
                              class: _vm.isFormHidden ? "fa-edit" : "fa-times",
                            }),
                          ]
                        ),
                      ]),
                      _c("transition", { attrs: { name: "slide" } }, [
                        !_vm.isFormHidden
                          ? _c("div", { attrs: { id: "form-body" } }, [
                              _c("div", { staticClass: "form-support" }, [
                                _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    " ¿Necesitas ayuda? Escríbenos si presentas algún problema y nuestros especialistas te atenderán lo más pronto posible. "
                                  ),
                                ]),
                                _c(
                                  "form",
                                  {
                                    staticClass: "inline",
                                    attrs: { action: "" },
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.createNewTicket()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "field is-horizontal" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "field-label is-normal",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "label subject-label",
                                              },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    attrs: {
                                                      id: "select-ticket-subject",
                                                      size: "is-small",
                                                      rounded: "",
                                                    },
                                                    model: {
                                                      value: _vm.inputSubject,
                                                      callback: function ($$v) {
                                                        _vm.inputSubject = $$v
                                                      },
                                                      expression:
                                                        "inputSubject",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.subjectsDictionary,
                                                    function (
                                                      dictionaryValue,
                                                      subject
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: subject,
                                                          domProps: {
                                                            value: subject,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                dictionaryValue
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "control" },
                                                  [
                                                    _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.inputMessage,
                                                          expression:
                                                            "inputMessage",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "textarea question-box",
                                                      attrs: {
                                                        id: "textarea-ticket-text",
                                                        placeholder:
                                                          "Escribe tu consulta",
                                                      },
                                                      domProps: {
                                                        value: _vm.inputMessage,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.inputMessage =
                                                            $event.target.value
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm.errors.message
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "help is-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.errors.message
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "field is-horizontal" },
                                      [
                                        _c("div", {
                                          staticClass: "field-label",
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "field-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "control" },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button is-button-primary is-pulled-right is-rounded",
                                                        attrs: {
                                                          id: "button-create-ticket",
                                                          type: "submit",
                                                        },
                                                      },
                                                      [_vm._v(" Enviar ")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "image-support" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/ui/assets/img/support.svg"),
                                    alt: "",
                                  },
                                }),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { attrs: { id: "support-history" } },
                [
                  _c("h4", { staticClass: "history-support-title" }, [
                    _vm._v(" Historial de consultas "),
                    _c("div", { staticClass: "field is-pulled-right" }, [
                      _c(
                        "div",
                        { staticClass: "control select is-rounded is-small" },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filteredStatus,
                                  expression: "filteredStatus",
                                },
                              ],
                              attrs: { id: "select-filter" },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.filteredStatus = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  _vm.renderTickets,
                                ],
                              },
                            },
                            _vm._l(
                              _vm.statusDictionary,
                              function (status, key) {
                                return _c(
                                  "option",
                                  {
                                    key: key,
                                    domProps: {
                                      value: key,
                                      selected: key === _vm.filteredStatus,
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(status) + " ")]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "spinner-content",
                      class: _vm.isLoading ? "is-loading" : "is-hidden",
                    },
                    [_vm._m(0)]
                  ),
                  !_vm.isLoading
                    ? _c(
                        "transition-group",
                        {
                          staticClass: "tickets",
                          attrs: {
                            name: "tickets-transition",
                            appear: "",
                            tag: "div",
                          },
                        },
                        [
                          _c(
                            "div",
                            { key: `ticket` },
                            [
                              _c(
                                "b-table",
                                {
                                  attrs: {
                                    "row-class": (row, i) => `help-ticket-${i}`,
                                    detailed: "",
                                    hoverable: "",
                                    data: _vm.filteredTickets,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "detail",
                                        fn: function (ticket) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                key: _vm.index,
                                                staticClass:
                                                  "ticket-details clearfix transition-slow show",
                                                attrs: {
                                                  id: `jajaja-${_vm.index}`,
                                                },
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "is-size-7 meta-data",
                                                  },
                                                  [
                                                    _c("li", [
                                                      _c("b", [
                                                        _vm._v(
                                                          "N° de atención:"
                                                        ),
                                                      ]),
                                                      _c("br"),
                                                      _vm._v(
                                                        " #" +
                                                          _vm._s(
                                                            ticket.row._id
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                    _vm.user.rol !== "CLIENT" &&
                                                    _vm.checkUserFeature(
                                                      "element.support.customer-support"
                                                    )
                                                      ? _c("li", [
                                                          _c("b", [
                                                            _vm._v("RUT:"),
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatRut(
                                                                  ticket.row
                                                                    .client
                                                                    .idNumber
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.user.rol !== "CLIENT" &&
                                                    _vm.checkUserFeature(
                                                      "element.support.customer-support"
                                                    )
                                                      ? _c("li", [
                                                          _c("b", [
                                                            _vm._v("Teléfono:"),
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                ticket.row
                                                                  .client.phone
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.user.rol !== "CLIENT" &&
                                                    _vm.checkUserFeature(
                                                      "element.support.customer-support"
                                                    )
                                                      ? _c(
                                                          "li",
                                                          {
                                                            attrs: {
                                                              id: "li-email",
                                                            },
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v("Mail:"),
                                                            ]),
                                                            _c("br"),
                                                            _vm._v(
                                                              _vm._s(
                                                                ticket.row
                                                                  .client.email
                                                              ) + " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.user.rol !== "CLIENT" &&
                                                    _vm.checkUserFeature(
                                                      "element.support.customer-support"
                                                    ) &&
                                                    ticket.row.client.balance
                                                      ? _c("li", [
                                                          _c("b", [
                                                            _vm._v("Saldo:"),
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatNumber(
                                                                  ticket.row
                                                                    .client
                                                                    .balance
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._l(
                                                  ticket.row.messages,
                                                  function (message, j) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: j,
                                                        staticClass:
                                                          "ticket-message",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-clearfix",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "title is-6 is-pulled-left",
                                                                class:
                                                                  message.from,
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getClientName(
                                                                        _vm.user,
                                                                        message,
                                                                        ticket.row
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "is-size-7 date-support-message is-pulled-right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.formatDate(
                                                                        message.createdAt,
                                                                        "DD/MM/YYYY[ a las ]HH:MM:ss"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "user-message",
                                                            attrs: {
                                                              id: `help-ticket-text-${j}`,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                message.text
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c("hr"),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "buttons is-right ticket-buttons",
                                                  },
                                                  [
                                                    _vm.user.rol !== "CLIENT" &&
                                                    _vm.checkUserFeature(
                                                      "element.support.customer-support"
                                                    ) &&
                                                    ticket.row.subject !==
                                                      "CONTACT_CHANGE" &&
                                                    ticket.row.status !==
                                                      "CLOSED"
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "customer-button",
                                                            attrs: {
                                                              id: `button-close-${0}`,
                                                              rounded: "",
                                                              size: "is-small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmToCloseTicket(
                                                                  ticket.row._id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" Cerrar ")]
                                                        )
                                                      : _vm._e(),
                                                    ticket.row.status !==
                                                      "CLOSED" &&
                                                    ticket.row.subject !==
                                                      "CONTACT_CHANGE"
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "is-button-primary",
                                                            attrs: {
                                                              id: "button-answer",
                                                              disabled:
                                                                !_vm.checkUserFeature(
                                                                  "element.support.button.responder"
                                                                ),
                                                              rounded: "",
                                                              size: "is-small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.launchModalMessage(
                                                                  ticket.row._id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Responder "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    ticket.row.status !==
                                                      "CLOSED" &&
                                                    ticket.row.subject ===
                                                      "CONTACT_CHANGE"
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "customer-button",
                                                            attrs: {
                                                              id: `button-rejected-${0}`,
                                                              rounded: "",
                                                              size: "is-small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.rejectEmailChange(
                                                                  ticket.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" Rechazar ")]
                                                        )
                                                      : _vm._e(),
                                                    ticket.row.status !==
                                                      "CLOSED" &&
                                                    ticket.row.subject ===
                                                      "CONTACT_CHANGE"
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass:
                                                              "is-button-primary",
                                                            attrs: {
                                                              id: "button-answer",
                                                              rounded: "",
                                                              size: "is-small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.checkEmailContact(
                                                                  ticket.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" Validar ")]
                                                        )
                                                      : _vm._e(),
                                                    ticket.row.status ===
                                                    "CLOSED"
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "is-size-7",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Esta consulta está cerrada, si quieres retomarla por favor crea una nueva indicando el N° de Atención. "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2590117318
                                  ),
                                },
                                [
                                  _vm.user.rol !== "CLIENT" &&
                                  _vm.checkUserFeature(
                                    "element.support.customer-support"
                                  )
                                    ? _c("b-table-column", {
                                        attrs: { field: "name" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ticket) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        ticket.row.client.name
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        ticket.row.client
                                                          .lastName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1605238900
                                        ),
                                      })
                                    : _vm._e(),
                                  _c("b-table-column", {
                                    attrs: { field: "subject" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ticket) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "tag subject-tag is-primary is-light is-size-6",
                                                },
                                                [
                                                  !ticket.row.isPublic
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa fa-house-user fa-lg is-private mr-2",
                                                        attrs: {
                                                          title:
                                                            "Ticket privado",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.subjectsDictionary[
                                                          ticket.row.subject
                                                        ] || ticket.row.subject
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      942462812
                                    ),
                                  }),
                                  _c("b-table-column", {
                                    attrs: { field: "date" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ticket) {
                                            return [
                                              _c("i", {
                                                staticClass:
                                                  "far fa-calendar fa-lg has-text-primary mr-1",
                                                attrs: {
                                                  title: "Fecha de creación",
                                                },
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    ticket.row.createdAt
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2698188271
                                    ),
                                  }),
                                  _c("b-table-column", {
                                    attrs: { field: "status" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ticket) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "round-content",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "round-color",
                                                    class: ticket.row.status,
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      846078186
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.filteredTickets.length
                    ? _c(
                        "div",
                        {
                          staticClass: "mt-5 mb-5",
                          staticStyle: { margin: "auto", display: "table" },
                        },
                        [_vm._v("Tickets no disponibles.")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c(
              "b-modal",
              {
                model: {
                  value: _vm.isModalActive,
                  callback: function ($$v) {
                    _vm.isModalActive = $$v
                  },
                  expression: "isModalActive",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-card-body" },
                  [
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "close-modal",
                          on: {
                            click: function ($event) {
                              _vm.isModalActive = false
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/ui/assets/img/plus-button.svg"),
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("h3", { staticClass: "modal-title" }, [
                      _vm._v("Responder"),
                    ]),
                    _c("section", { staticClass: "modal-card-body" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Mensaje"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newMessageForm.message,
                                expression: "newMessageForm.message",
                              },
                            ],
                            staticClass: "textarea",
                            attrs: { id: "textarea-answer" },
                            domProps: { value: _vm.newMessageForm.message },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newMessageForm,
                                  "message",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm.user.rol !== "CLIENT" &&
                      _vm.checkUserFeature("element.support.customer-support")
                        ? _c("label", { staticClass: "checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newMessageForm.closeCurrentTicket,
                                  expression:
                                    "newMessageForm.closeCurrentTicket",
                                },
                              ],
                              attrs: {
                                id: "checkbox-close-ticket",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.newMessageForm.closeCurrentTicket
                                )
                                  ? _vm._i(
                                      _vm.newMessageForm.closeCurrentTicket,
                                      null
                                    ) > -1
                                  : _vm.newMessageForm.closeCurrentTicket,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.newMessageForm.closeCurrentTicket,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.newMessageForm,
                                          "closeCurrentTicket",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.newMessageForm,
                                          "closeCurrentTicket",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.newMessageForm,
                                      "closeCurrentTicket",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(" Además cerrar consulta "),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "b-button",
                      {
                        staticClass: "is-button-primary is-pulled-right",
                        attrs: { id: "button-send-answer", rounded: "" },
                        on: {
                          click: function ($event) {
                            return _vm.addNewReply()
                          },
                        },
                      },
                      [_vm._v(" Responder ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _c("div", { staticClass: "double-bounce2" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }